import { fetchAuthProviders } from '../api/auth_provider'
import type { Resolvers } from '../generated/server/resolvers'

const AuthProviderResolver: Resolvers = {
  Query: {
    authenticationProviders: () => fetchAuthProviders(),
  },
}

export default AuthProviderResolver
